import { Action, HomePolicy } from '@models/swagger';
import { createAction, props } from '@ngrx/store';

export enum PolicyActions {
  ClearData = '[Flow Data Policy] Clear Data',
  UpdatePolicy = '[Flow Data Policy] Update Policy',
  EmptyPolicy = '[Flow Data Policy] Empty Policy',
  SelectAction = '[Flow Data Policy] Select Action',
  EmptySelectedAction = '[Flow Data Policy] Empty Selected Action',
}

export const PolicyClearData = createAction(PolicyActions.ClearData);

export const PolicyUpdatePolicy = createAction(PolicyActions.UpdatePolicy, props<{ data: HomePolicy }>());

export const PolicyEmptyPolicy = createAction(PolicyActions.EmptyPolicy);

export const PolicySelectAction = createAction(PolicyActions.SelectAction, props<{ data: Action }>());

export const PolicyEmptySelectedAction = createAction(PolicyActions.EmptySelectedAction);
